/**
 * @CE liweikang
 */
import React from 'react';
import Button from '@material-ui/core/Button';
import { CallService } from '../constants/type.constant';
import { Input } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import '../resources/css/call-waiter.css';
import callWaiterIcon from '../assets/callWaiter.png';
import { DefaultRequest } from '../requests/default.request';
import io from 'socket.io-client';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { WebsocketClient } from '../websocket/module';
import i18n from '../i18n';
import { getWebsocketUrl } from '../tools/utils';
import { getCacheField } from '../tools/get-cache-field';
import { MessengerModule } from '../messenger/module';
import { withSnackbar, WithSnackbarProps } from 'notistack';

class CallWaiter extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    public inputRefs: any;
    constructor(props: Props) {
        super(props);
        this.state = {
            //呼叫服务资源
            callService: [],
            // 呼叫信息
            message: '',
            // 打开是否呼叫模态框
            openDialog: false,
            // 桌台号（编辑）
            tableText: ''
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }
    // *********************
    // 生命周期
    // *********************
    public componentDidMount() {
        //获取呼叫服务资源
        this.getCallService();
        WebsocketClient.addListener('REVIEW_FAIL', (data: any) => {
            console.log('REVIEW_FAIL', data);
        })
        WebsocketClient.on('REVIEW_FAIL', (data: any) => {
            console.log('REVIEW_FAIL', data);
        })
        WebsocketClient.on('REVIEW_SUCCES', (data: any) => {
            console.log('REVIEW_SUCCES', data);
        })
    }


    // *********************
    // 方法区
    // *********************
    // 根据国际化筛选title
    public filterName(item: any, language: string) {
        // EN IT ZH ES DE FR
        let title = ''
        switch (language) {
            case 'ZH':
                title = item.title_cn;
                break
            case 'EN':
                title = item.title_en;
                break
            case 'IT':
                title = item.title_it;
                break
            case 'ES':
                title = item.title_es;
                break
            case 'DE':
                title = item.title_de;
                break
            case 'FR':
                title = item.title_fr;
                break
            default:
                title = item.title_en;
                break
        }
        return title || item.title_en;
    }
    // 根据国际化筛选title
    public filterValue(item: any, language: string) {
        // EN IT ZH ES DE FR
        let value = ''
        switch (language) {
            case 'ZH':
                value = item.value_cn;
                break
            case 'EN':
                value = item.value_en;
                break
            case 'IT':
                value = item.value_it;
                break
            case 'ES':
                value = item.value_es;
                break
            case 'DE':
                value = item.value_de;
                break
            case 'FR':
                value = item.value_fr;
                break
            default:
                value = item.value_en;
                break
        }
        return value || item.value_en;
    }
    //获取呼叫服务资源
    public async getCallService() {
        let callService: CallService = await DefaultRequest.getCallService();
        let language = i18n.language;
        this.setState({
            callService: callService.map((item) => ({
                title: this.filterName(item, language),
                value: this.filterValue(item, language),
                selected: false,
                id: item.id,
            }))
        })
    }

    /**
     * 点击呼叫选项
     * @param id 选择的附加服务id
     * */
    clickCallService = (id: number) => {
        let { callService } = this.state;
        callService.forEach(item => {
            if (item.id === id) {
                item.selected = !item.selected
            }
        })
        this.setState({
            callService,
        })

    }
    //呼叫服务
    callService = () => {
        let { callService, message, tableText } = this.state;
        let checkbox_group: string[] = [];
        callService.forEach((item) => {
            if (item.selected) {
                checkbox_group.push(item.title)
            }
        });
        try {
            // const strArr = (Store.getState().serverUrl).split(':')
            // const serverUrl = strArr[1].split('//')
            // const msgSocket = io(`ws://${serverUrl[1]}:3002`);
            const msgSocket = io(`ws://${getWebsocketUrl()}`);
            msgSocket.emit('CALL_SERVICE', {
                table_id: getCacheField('tableId'),
                table_name: (this.props.lite && tableText) ?? getCacheField('tableName'),
                message,
                checkbox_group,
                customer: getCacheField('orderTab.customer'),
                order_id: getCacheField('orderTab.orderId'),
                project_name: 'QOP',
                type: 'CALL_SERVICE',
            });
            callService.forEach(item => {
                item.selected = false
            })
            this.setState({
                callService,
                message: '',
                tableText: ''
            })
            this.messengerModule.say({
                message: `${i18n.t('service_page_text_call_service_success_message')}`,
                level: "Success",
            });
        } catch (error) {
            throw error;
        }
    }

    scrollTo(top: boolean) {
        // 解决安卓浏览器软键盘覆盖页面问题
        if (navigator.userAgent.match(/(android);?/i)) {
            if (this.inputRefs) {
                this.inputRefs?.scrollTo(0, top ? 0 : 200);
            }
        }
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { lite } = this.props;
        const { callService, message, openDialog, tableText } = this.state;
        // 呼叫服务按钮
        let callBtnDisabled = () => {
            let callServiceResult = false;
            let messageResult;
            callService.forEach((item) => {
                if (item.selected) {
                    callServiceResult = true;
                }
            })

            if (message.trim().length > 0) {
                messageResult = true;
            } else {
                messageResult = false;
            }
            if (lite && !tableText) {
                return false
            }
            return callServiceResult || messageResult;
        }
        return (
            <div className="callWaiter" ref={(refs) => { this.inputRefs = refs; }}>
                {lite && <div className="tableTextBox">
                    <div className="label">
                        {i18n.t('service_page_text_table_name')}
                    </div>
                    <div className="tableInputBox">
                        <Input
                            value={this.state.tableText}
                            disableUnderline
                            fullWidth
                            onChange={(event) => { event?.target?.value?.length < 30 && this.setState({ tableText: event.target.value }) }}
                            color="primary" />
                    </div>
                </div>}
                <div className="box">
                    <div className="label">
                        {i18n.t('service_page_text_Please_select_a_service')}
                    </div>
                    <div className="select-value">
                        <Grid container spacing={2}>
                            {
                                callService.map((item, index) => (
                                    <Grid item xs={6} key={index}>
                                        <Button
                                            onClick={() => this.clickCallService(item.id)}
                                            fullWidth
                                            className={item.selected ? 'themeColor callService active' : 'themeColor callService'}>
                                            {item.title}
                                        </Button>
                                    </Grid>
                                )
                                )
                            }
                        </Grid>
                    </div>
                </div>
                <div className="box" style={{ height: '30vh' }}>
                    <div className="label">
                        {i18n.t('service_page_text_Your_requirement')}
                    </div>
                    <div className="value">
                        <Input
                            placeholder={i18n.t('service_page_input_placeholder_message')}
                            onFocus={() => {
                                this.scrollTo(false);
                            }}
                            onBlur={() => {
                                this.scrollTo(true);
                            }}
                            value={this.state.message}
                            rows={3}
                            multiline
                            disableUnderline
                            fullWidth
                            onChange={(event) => { this.setState({ message: event.target.value }) }}
                            color="primary" />
                    </div>
                </div>
                <div className="box">
                    <Button
                        disabled={!callBtnDisabled()}
                        className="callBtn"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => { this.callService() }}>
                        <img src={callWaiterIcon} alt={i18n.t('service_page_text_call_waiter')} width="30" />
                        <div className="label" >{i18n.t('service_page_text_call_waiter')}</div>
                    </Button>
                </div>

                <Dialog
                    className="callBtnDialog"
                    open={openDialog}
                    onClose={() => { this.setState({ openDialog: false }) }}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{i18n.t('service_page_text_call_service')}</DialogTitle>
                    <DialogActions>
                        <Button fullWidth variant="contained" onClick={() => { this.setState({ openDialog: false }) }} color="primary">
                            {i18n.t('general_button_cancel')}
                        </Button>
                        <Button fullWidth variant="contained" onClick={() => { this.setState({ openDialog: false }); this.callService() }} color="primary">
                            {i18n.t('general_button_sure')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}
export default withSnackbar(CallWaiter)
// **********
// TYPE
// **********

type Props = {
    // 菜单模式
    lite?: boolean;
} & WithSnackbarProps

type State = {
    //呼叫服务资源
    callService: Array<{ id: number, title: string, value: string, selected: boolean }>,
    // 呼叫信息
    message: string,
    // 打开是否呼叫模态框
    openDialog: boolean,
    // 桌台号（编辑）
    tableText: string;
}

